import { render, staticRenderFns } from "./InventoryLockConfirmModal.vue?vue&type=template&id=d2ccab12"
import script from "./InventoryLockConfirmModal.vue?vue&type=script&lang=js"
export * from "./InventoryLockConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports